import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ZALO_OAID } from '../../../configs/SocialConfig';

class ZaloShareButton extends PureComponent {
  render() {
    const { children, url } = this.props;
    return (
      <div
        className="zalo-share-button d-inline-block"
        data-href={url}
        data-oaid={ZALO_OAID}
        data-layout="2"
        data-color="blue"
        data-customize={true}
      >
        {children}
      </div>
    );
  }
}

ZaloShareButton.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
};

export default ZaloShareButton;
